import { Alert, Anchor } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useEffect, useState } from 'react';

import { useParams } from 'react-router';
import useFetch from '../helpers/useFetch';
import ErrorMessage from './ErrorMessage';

const UsageAlerts = () => {
  const { accountId, domainId } = useParams();
  const [usage, setUsage] = useState();
  const [error, setError] = useState();
  const fetch = useFetch();

  useEffect(() => {
    setUsage(undefined);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/usage`)
      .then((usage) => {
        setUsage(usage);
      })
      .catch(setError);
  }, [accountId, domainId, fetch]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (usage === undefined) {
    return '';
  }

  let emailAlertText;
  if (usage.billingPeriod && usage.currentEmailUsage && usage.allowedEmailUsage) {
    const emailUsageRate = parseInt((usage.currentEmailUsage / usage.allowedEmailUsage) * 100.0);
    if (emailUsageRate >= 100) {
      emailAlertText = (
        <>
          You have reached the {usage.allowedEmailUsage.toLocaleString(navigator.language)} email send limit for the
          current billing period and email sending is disabled. This limit will reset on{' '}
          {new Date(usage.billingPeriod.end).toLocaleString(navigator.language)}. Please contact{' '}
          <Anchor href="mailto:support@releva.ai">support@releva.ai</Anchor> to upgrade your plan or purchase additional
          email packages.
        </>
      );
    } else if (emailUsageRate >= 80) {
      emailAlertText = (
        <>
          You have reached {Math.min(100, emailUsageRate)}% of the{' '}
          {usage.allowedEmailUsage.toLocaleString(navigator.language)} email send limit during the current billing
          period. This limit will reset on {new Date(usage.billingPeriod.end).toLocaleString(navigator.language)}.
          Please contact <Anchor href="mailto:support@releva.ai">support@releva.ai</Anchor> to upgrade your plan or
          purchase additional email packages.
        </>
      );
    }
    return (
      <>
        {emailAlertText ? (
          <Alert color={emailUsageRate >= 100 ? 'red' : 'yellow'} icon={<IconAlertTriangle size={18} />}>
            {emailAlertText}
          </Alert>
        ) : null}
      </>
    );
  }
  return '';
};

export default UsageAlerts;
